import React from 'react';
import { IHelpSidebarPanel } from './interfaces';
import { ContentPanel } from '@components/ContentPanel';
import { Button, Stack, Typography } from '@mui/material';

export const HelpSidebarPanel: React.FC<
  IHelpSidebarPanel
> = ({}): JSX.Element => {
  return (
    <ContentPanel borderRadius="none" title="Hulp & uitleg">
      <Stack spacing={1}>
        <Typography variant="body2">
          • Klik op een dienst om je in te schrijven
        </Typography>
        <Typography variant="body2">
          • Sommige diensten vereisen een certificaat
        </Typography>
        <Typography variant="body2">
          • Kun je toch niet? Schrijf je tijdig uit
        </Typography>
      </Stack>

      <Button size="small" variant="outlined" fullWidth sx={{ mt: 2 }}>
        Meer uitleg
      </Button>
    </ContentPanel>
  );
};
